module.exports = __webpack_public_path__ + "static/media/tab_Group40.d841941c.png";